module.exports = __webpack_public_path__ + "static/media/BieSjefke_Logo_Zomer_RGB-removebg-preview (1).11afa407.png";